import { DataSource } from '@angular/cdk/collections';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject, Observable, ReplaySubject, Subscription } from 'rxjs';
import Permission from 'src/app/interfaces/permission';
import { SubStatusesService } from '../sub-statuses/sub-statuses.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import moment from 'moment';
import {DateTimeService} from "../../../services/date-time.service";
import {DatePipe} from "@angular/common";

interface SubstatusDateTable {
  id: string;
  subsequence_id: string;
  substatus_id: string;
  project_status_id: number;
  status: string;
  subsequence: string;
  permissions: Permission;
  date: string;
  time: string;
  timezone: string;
  target: boolean;
  subsequenceObj: any;
  substatusObj: any;
  substatusDateObj: any;
}

class SubstatusDateDataSource extends DataSource<SubstatusDateTable> {
  private _data = new ReplaySubject<SubstatusDateTable[]>();
  constructor(initialData: SubstatusDateTable[]) {
    super();
    this.setData(initialData);
  }
  connect(): Observable<SubstatusDateTable[]> {
    return this._data;
  }
  disconnect() {}
  setData(data: SubstatusDateTable[]) {
    this._data.next(data);
  }
}

@Component({
    selector: 'sub-status-dates-table',
    templateUrl: './sub-status-dates-table.component.html',
    styleUrls: ['./sub-status-dates-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SubStatusDatesTableComponent {
  @Input() subsequences: any[];
  @Input() editMode: boolean;
  public projectSubstatusDates: any[] | null;
  @Input() project_status_id: number;
  public tableData: SubstatusDateTable[] = [];
  public dataSource: MatTableDataSource<SubstatusDateTable> =
    new MatTableDataSource<SubstatusDateTable>();
  public columns: string[] = ['status', 'subsequence', 'date', 'time', 'target'];
  public substatusDatesSub: Subscription;
  public today: string;

  constructor(public substatusService: SubStatusesService, public dateTimeService: DateTimeService, public datePipe: DatePipe) {}
  ngOnInit() {
    this.substatusDatesSub = this.substatusService
      .getProjectSubstatusDates()
      .subscribe((projectSubstatusDates) => {
        this.projectSubstatusDates = projectSubstatusDates;
        this.formatData();
        this.dataSource.data = this.tableData;
      });
    this.today = moment.utc().format('YYYY-MM-DD');
  }
  ngOnDestroy() {
    this.substatusDatesSub?.unsubscribe();
  }
  formatData() {
    this.tableData = [];
    for (let i = 0; i < this.subsequences.length; i++) {
      let subsequence = this.subsequences[i];
      for (let j = 0; j < subsequence.substatuses.length; j++) {
        let substatus = subsequence.substatuses[j];
        let date = this.getSubstatusDate(
          subsequence.id,
          substatus.id,
          this.project_status_id
        );
        let data: SubstatusDateTable = {
          id: date?.id ?? '',
          subsequence_id: subsequence.id,
          substatus_id: substatus.id,
          project_status_id: this.project_status_id,
          status: substatus.name,
          subsequence: subsequence.name,
          date: date?.date ?? '',
          time: date?.utc_time ?? '',
          timezone: date?.timezone ?? '',
          permissions: subsequence.permissions,
          target: date?.target ?? false,
          subsequenceObj: subsequence,
          substatusDateObj: date,
          substatusObj: substatus,
        };
        this.tableData.push(data);
      }
    }
  }
  queueTargetChange(element: SubstatusDateTable, $event: MatCheckboxChange) {
    element.target = $event.checked;
    let { id, substatus_id, subsequence_id, project_status_id, date, time, timezone, target } =
      element;
    if (date.length > 0)
      this.substatusService.queueProjectSubstatusDateUpdate({
        id,
        substatus_id,
        subsequence_id,
        project_status_id,
        date,
        time,
        timezone,
        target,
      });
  }
  changeSubstatusDate(element: SubstatusDateTable, $event: any) {
    element.date = $event.date;
    element.target = $event.target;
  }

  changeSubstatusTime(element:SubstatusDateTable, $event:any){
    element.time = $event.time;
    element.timezone = $event.timezone
  }

  formatTime(time:any, timezone:any){
    let convertedTime;
    let convertedTimezone = this.dateTimeService.timezones.find((tz) => tz.tz == timezone);

    let newDate = new Date();
    let dateVal = newDate.toLocaleString()
    let dateArr = dateVal.split(',')
    let utcDate = new Date(dateArr[0] + " " + time + " " + "UTC");
    let isDST = this.dateTimeService.isDST(utcDate)
    let zoneAbbr = isDST ? convertedTimezone?.dstabbr : convertedTimezone?.abbr
    convertedTime = this.datePipe.transform(utcDate, 'h:mm a', zoneAbbr ?? 'EST')
    return convertedTime + " " + convertedTimezone?.abbr;
  }
  getSubstatusDate(
    subsequence_id: any,
    substatus_id: any,
    project_substatus_id: any
  ) {
    return this.projectSubstatusDates?.find(
      (projectSubstatusDate) =>
        projectSubstatusDate.substatus_id === substatus_id &&
        projectSubstatusDate.subsequence_id === subsequence_id &&
        projectSubstatusDate.project_status_id === project_substatus_id
    );
  }
}
